import { render, staticRenderFns } from "./Construction.vue?vue&type=template&id=73c622ff&"
import script from "./Construction.vue?vue&type=script&lang=js&"
export * from "./Construction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports